import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppStore } from '@/app/providers/app-store'

/**
 * Sync the persisted locale with the `?lang=ar|en` query parameter.
 *
 * When a search engine (or shared link) lands on a URL with
 * `?lang=en`, switch the app to English so the SSR-rendered meta
 * matches what the user (and Googlebot's second JS-render pass) sees.
 * Without this, hreflang alternates would all render in the
 * persisted locale, defeating the purpose of dual indexation.
 *
 * Used in `PublicLayout` so it runs across every public route.
 */
export function useLocaleSync(): void {
  const { search } = useLocation()
  const setLocale = useAppStore((s) => s.setLocale)
  const locale = useAppStore((s) => s.locale)

  useEffect(() => {
    const params = new URLSearchParams(search)
    const lang = params.get('lang')
    if (lang === 'ar' || lang === 'en') {
      if (lang !== locale) setLocale(lang)
    }
  }, [search, locale, setLocale])
}
